import styled from "styled-components";

interface SpinnerDSProps {
  size?: number;
}

export const SpinnerDS = (props: SpinnerDSProps) => {
  return (
    <StyledSpinner $size={props.size ?? 3}>
      <div className="dot-spin" />
    </StyledSpinner>
  );
};

const StyledSpinner = styled.div<{ $size: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => `${$size}rem`};
  height: ${({ $size }) => `${$size}rem`};

  .dot-spin {
    transform: scale(${({ $size }) => $size / 3});
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: transparent;
    color: transparent;
    box-shadow:
      0 -18px 0 0 #63d195,
      12.727926px -12.727926px 0 0 #63d195,
      18px 0 0 0 #63d195,
      12.727926px 12.727926px 0 0 #efe74e,
      0 18px 0 0 #efe74e,
      -12.727926px 12.727926px 0 0 #efe74e,
      -18px 0 0 0 #efe74e,
      -12.727926px -12.727926px 0 0 #efe74e;
    animation: dot-spin 1.5s infinite linear;
  }

  @keyframes dot-spin {
    0%,
    100% {
      box-shadow:
        0 -18px 0 0 #63d195,
        12.727926px -12.727926px 0 0 #63d195,
        18px 0 0 0 #63d195,
        12.727926px 12.727926px 0 -5px #efe74e,
        0 18px 0 -5px #efe74e,
        -12.727926px 12.727926px 0 -5px #efe74e,
        -18px 0 0 -5px #efe74e,
        -12.727926px -12.727926px 0 -5px #efe74e;
    }
    12.5% {
      box-shadow:
        0 -18px 0 -5px #efe74e,
        12.727926px -12.727926px 0 0 #63d195,
        18px 0 0 0 #63d195,
        12.727926px 12.727926px 0 0 #63d195,
        0 18px 0 -5px #efe74e,
        -12.727926px 12.727926px 0 -5px #efe74e,
        -18px 0 0 -5px #efe74e,
        -12.727926px -12.727926px 0 -5px #efe74e;
    }
    25% {
      box-shadow:
        0 -18px 0 -5px #efe74e,
        12.727926px -12.727926px 0 -5px #efe74e,
        18px 0 0 0 #63d195,
        12.727926px 12.727926px 0 0 #63d195,
        0 18px 0 0 #63d195,
        -12.727926px 12.727926px 0 -5px #efe74e,
        -18px 0 0 -5px #efe74e,
        -12.727926px -12.727926px 0 -5px #efe74e;
    }
    37.5% {
      box-shadow:
        0 -18px 0 -5px #efe74e,
        12.727926px -12.727926px 0 -5px #efe74e,
        18px 0 0 -5px #efe74e,
        12.727926px 12.727926px 0 0 #63d195,
        0 18px 0 0 #63d195,
        -12.727926px 12.727926px 0 0 #63d195,
        -18px 0 0 -5px #efe74e,
        -12.727926px -12.727926px 0 -5px #efe74e;
    }
    50% {
      box-shadow:
        0 -18px 0 -5px #efe74e,
        12.727926px -12.727926px 0 -5px #efe74e,
        18px 0 0 -5px #efe74e,
        12.727926px 12.727926px 0 -5px #efe74e,
        0 18px 0 0 #63d195,
        -12.727926px 12.727926px 0 0 #63d195,
        -18px 0 0 0 #63d195,
        -12.727926px -12.727926px 0 -5px #efe74e;
    }
    62.5% {
      box-shadow:
        0 -18px 0 -5px #efe74e,
        12.727926px -12.727926px 0 -5px #efe74e,
        18px 0 0 -5px #efe74e,
        12.727926px 12.727926px 0 -5px #efe74e,
        0 18px 0 -5px #efe74e,
        -12.727926px 12.727926px 0 0 #63d195,
        -18px 0 0 0 #63d195,
        -12.727926px -12.727926px 0 0 #63d195;
    }
    75% {
      box-shadow:
        0 -18px 0 0 #63d195,
        12.727926px -12.727926px 0 -5px #efe74e,
        18px 0 0 -5px #efe74e,
        12.727926px 12.727926px 0 -5px #efe74e,
        0 18px 0 -5px #efe74e,
        -12.727926px 12.727926px 0 -5px #efe74e,
        -18px 0 0 0 #63d195,
        -12.727926px -12.727926px 0 0 #63d195;
    }
    87.5% {
      box-shadow:
        0 -18px 0 0 #63d195,
        12.727926px -12.727926px 0 0 #63d195,
        18px 0 0 -5px #efe74e,
        12.727926px 12.727926px 0 -5px #efe74e,
        0 18px 0 -5px #efe74e,
        -12.727926px 12.727926px 0 -5px #efe74e,
        -18px 0 0 -5px #efe74e,
        -12.727926px -12.727926px 0 0 #63d195;
    }
  }
`;
